import { indexTree } from "app/pages/sales-intelligence/utils/taxonomy-tree/tree";
import type { TaxonomyNode } from "app/pages/sales-intelligence/utils/taxonomy-tree/types";

import type { IntentTaxonomyDescriptionDto } from "../types/dto";
import type { IntentNodeId, IntentTaxonomyIndex } from "../types/taxonomy";
import { createIntentNodeId } from "../types/taxonomy";

/**
 * Builds the intent description into the generic taxonomy tree.
 *
 * The nesting — parent categories, categories, topics — is intent's own shape. The wire ids are unique
 * per level rather than across the tree, so whole-tree ids are synthesized positionally.
 */
export const buildIntentTaxonomyTree = (dto: IntentTaxonomyDescriptionDto): readonly TaxonomyNode<IntentNodeId>[] =>
    dto.parentCategories.map((parent, parentIndex) => ({
        id: createIntentNodeId([parentIndex]),
        name: parent.name,
        children: parent.children.map((category, categoryIndex) => ({
            id: createIntentNodeId([parentIndex, categoryIndex]),
            name: category.name,
            children: category.children.map((topic, topicIndex) => ({
                id: createIntentNodeId([parentIndex, categoryIndex, topicIndex]),
                name: topic.name,
                children: [],
            })),
        })),
    }));

export const indexIntentTaxonomy = (dto: IntentTaxonomyDescriptionDto): IntentTaxonomyIndex =>
    indexTree(buildIntentTaxonomyTree(dto));
